/**
 * Trạng thái nộp dự toán
 */
export default {
    /**
     * Chưa nộp
     */
    NotSent: 0,
    /**
     * Đã nộp/ Đang kiểm tra
     */
    Sent: 5,
};
